import Swiper from 'swiper'

window.addEventListener('DOMContentLoaded', function () {
  const $apsCalloutTiles = document.querySelectorAll('.aps-callout-tiles')
  if (
    $apsCalloutTiles.length &&
    window.innerWidth < 768 &&
    document.documentElement.classList.contains('touchevents')
  ) {
    Array.from($apsCalloutTiles).forEach(($component) => {
      new Swiper($component, {
        createElements: true,
        slidesPerView: 1.25,
        slideClass: 'aps-callout-tile',
        spaceBetween: 20,
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            spaceBetween: 30,
          },
        },
      })
    })
  }
})
